import dayjs from 'dayjs';

import { OfficialAccountVerifyStatus } from '@/hooks/useOfficialAccount';
import { shorten, getTimeInFeed, isOfficalAddress } from '@/utils';

import { FeedArticle, FeedComment } from '../types';
import { isEmpty } from 'lodash';
import { formatStreamValue } from './list';

export const transAuthor = ({
  user,
  maxMemoLength = 16,
  showMemo = true,
}: {
  user?: UnionAccount;
  maxMemoLength?: number;
  showMemo?: boolean;
}) => {
  if (!user) {
    return '';
  }

  const isOffical = isOfficalAddress(user.id);

  if (isOffical) {
    return (user as OfficialAccount)?.verify_status === OfficialAccountVerifyStatus.INACTIVE
      ? ''
      : (user as OfficialAccount)?.name;
  }

  const { memo, web3_id } = (user as GeneralAccount)?.desc?.user || {};

  return `${web3_id || shorten(user.id, 6, 4)}${
    memo ? ` (${memo.length > maxMemoLength ? `${memo.slice(0, maxMemoLength)}...` : memo})` : ''
  }`;
};

export const getShowVip = (user?: UnionAccount) => {
  if (!user) {
    return false;
  }

  const isOffical = isOfficalAddress(user.id);

  if (isOffical) {
    return false;
  }

  const { web3_id } = (user as GeneralAccount)?.desc?.user || {};
  return Boolean((user as GeneralAccount).is_vip && web3_id);
};

export const transComment = (comment: FeedComment) => {
  comment._daytime = getTimeInFeed(comment.create_at);
  comment._fulltime = dayjs.unix(comment.create_at).format('hh:mm A · MMM DD YYYY');
  comment._author = transAuthor({ user: comment.creator });
  comment._trustCount = formatStreamValue(comment.trust_count);
  comment._distrustCount = formatStreamValue(comment.distrust_count);
  comment._showVip = getShowVip(comment.creator);

  if (comment.reply_to_user) {
    comment._replyTo = transAuthor({ user: comment.reply_to_user });
  }

  return comment;
};

export const getDetailPageTitle = (article?: FeedArticle) => {
  if (!article) return 'Stream';
  const { content, creator, images } = article;
  const author = transAuthor({ user: creator, showMemo: false });
  const shortContent = shorten(content, 12, 12);
  const hasImage = !isEmpty(images);
  return `${author} on stream: "${content ? shortContent : hasImage ? 'picture' : ''}"`;
};

export const isHashTag = (str: string) => {
  return str.startsWith('#') || str.startsWith('$');
};

export const checkTrialReached = (reason?: string) =>
  reason?.includes('Your trial limit has been reached');
